import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyCheckAlt } from "@fortawesome/free-solid-svg-icons";
//import moment from 'moment';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button/Button";
import { withRouter } from "react-router";
import { AdminView } from "./admin_view.component";
import PropTypes from "prop-types";
import { cancelMotiveMap, requestPeriodsMap } from "../utils/cancel.constants";
import Tooltip from "@material-ui/core/Tooltip";
import NodeModal from "./modal.component";
import { formatDateTimeSmall } from "../utils/time.utils";
import { withStyles } from "@material-ui/core/styles";

var moment = require("moment-timezone");

String.prototype.trunc = function (n, useWordBoundary) {
  if (this.length <= n) {
    return this;
  }
  var subString = this.substr(0, n - 1);
  return (
    (useWordBoundary
      ? subString.substr(0, subString.lastIndexOf(" "))
      : subString) + "..."
  );
};

class UserRequestCardExclusive extends React.Component {
  state = {
    notes: false,
  };

  constructor() {
    super();
    this.goTo = this.goTo.bind(this);
  }

  goTo(location) {
    this.props.history.push(location);
  }

  isCanceled = () => {
    if (this.isAdmitted()) return false;
    return !!this.props.request.is_canceled;
  };

  isAdmitted = () => {
    return !!this.props.request.request_admitted;
  };

  isPending = () => {
    const { request } = this.props;
    return (
      !this.isCanceled() &&
      !this.isAdmitted() &&
      request.admin_id &&
      !request.forward_count &&
      !this.isStandby()
    );
  };

  isPreAdmitted = () => {
    const { request } = this.props;
    if (
      request.preadmitted_count === 1 &&
      !this.isCanceled() &&
      !this.isStandby() &&
      !this.isAdmitted()
    )
      return true;
  };

  isInProgress = () => {
    const { request } = this.props;
    if (this.isStandby() || request.preadmitted_count === 1) return false;
    return (
      !this.isCanceled() &&
      !this.isAdmitted() &&
      request.admin_id &&
      !!request.forward_count
    );
  };

  isStandby = () => {
    const { request } = this.props;
    return !this.isCanceled() && request.standby;
  };

  isNew = () => {
    if (this.isCanceled()) return false;
    if (this.isAdmitted()) return false;
    if (this.isInProgress()) return false;
    return !this.props.request.admin_id;
  };

  getName() {
    const { request } = this.props;
    const realName = (request.user_id ? request.user_name : request.name) || "";
    return realName.toLowerCase();
  }

  handleCloseModal = () => {
    this.setState({ notes: false });
  };

  handleOpenModal = () => {
    this.setState({ notes: true });
  };

  getNotes = () => {
    const { request } = this.props;
    if (request.notes && request.notes.length > 0) {
      return request.notes.slice(-1);
    }
    return "";
  };

  render() {
    const { request, classes } = this.props;
    const requestPeriodClass =
      request.request_period_id === 2
        ? "admission_date_mild"
        : request.request_period_id === 1
        ? "admission_date_urgent"
        : "admission_date_unknown";
    const notes = this.getNotes();
    const name = this.getName();

    //RECEBER E MOSTRAR O ULTIMO AGENDAMENTO, DESDE Q IGUAL OU SUPERIOR AO DIA DE HOJE
    let bookcalls_length =
      request.bookcalls.length !== 0 ? request.bookcalls.length - 1 : null;
    let bookcall =
      bookcalls_length === null
        ? null
        : moment(request.bookcalls[bookcalls_length].book_to).format(
            "YYYY-MM-DD HH:mm"
          );
    const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm");

    let cardTimestamp;

    return (
      <Paper
        className={
          "exclusive-card " +
          (this.isAdmitted() ? " green-background " : "") +
          `${this.isNew() && " help-card "}` +
          (this.isCanceled() ? " canceled " : "") +
          (this.isStandby() ? " standby " : "") +
          (this.isPreAdmitted() ? " preadmitted " : "")
        }
      >
        <NodeModal
          open={this.state.notes}
          handleClose={this.handleCloseModal}
        />

        <Grid container>
          <Grid item md={8}>
            <Grid container alignItems={"center"}>
              <Grid item md={2}>
                <Typography variant="body2">
                  {moment(request.assigned_to_at || request.created_at).format(
                    "YYYY-MM-DD [às] HH:mm"
                  )}
                </Typography>
              </Grid>
              <Grid item md={2}>
                <Typography variant="body2">
                  {request.proposed_price > 0 && (
                    <Tooltip title="Mensalidade Proposta">
                      <span className="signs-span">
                        <FontAwesomeIcon icon="euro-sign" />
                        {request.proposed_price}
                      </span>
                    </Tooltip>
                  )}
                </Typography>
              </Grid>
              <Grid item md={1}>
                <Grid container justify={"flex-end"}>
                  <Tooltip title={requestPeriodsMap[request.request_period_id]}>
                    <span
                      className={`establishment_flag ${requestPeriodClass}`}
                    >
                      <FontAwesomeIcon icon="clock" />
                    </span>
                  </Tooltip>
                  {request.establishment_valence && (
                    <Tooltip
                      title={
                        request.establishment_valence
                          ? request.establishment_valence.establishment.name
                          : ""
                      }
                    >
                      <span
                        className={request.payed_plan ? classes.payment_ok : ""}
                        style={{ marginRight: "5px" }}
                      >
                        <FontAwesomeIcon icon="home" />
                      </span>
                    </Tooltip>
                  )}
                </Grid>
              </Grid>
              <Grid item md={2}>
                <Typography variant="body2">
                  <b>Encaminhado</b>
                </Typography>
              </Grid>

              <Grid item md={3}>
                <AdminView
                  adminId={request.admin_id}
                  label={"CF"}
                  image={true}
                />
              </Grid>
              <Grid item md={2}>
                <Typography variant="body2">
                  <Tooltip
                    color="white"
                    backgroundColor="#0a334c"
                    fontSize="12px"
                    title="Total de Encaminhamentos"
                  >
                    <span className="signs-span">
                      <FontAwesomeIcon icon="share" />
                      {request.forward_count || 0}
                    </span>
                  </Tooltip>
                  <Tooltip title="Total de Aceitações">
                    <span className="signs-span">
                      <FontAwesomeIcon icon="check" />
                      {request.accepted_count || 0}
                    </span>
                  </Tooltip>
                  <Tooltip title="Total de Contactos">
                    <span className="signs-span">
                      <FontAwesomeIcon icon="comments" />
                      {request.contact_count || 0}
                    </span>
                  </Tooltip>
                  <Tooltip title="Total de Visitas Realizadas">
                    <span className="signs-span">
                      <FontAwesomeIcon icon="eye" />
                      {request.visits_done_count || 0}
                    </span>
                  </Tooltip>
                  <Tooltip title="Total de Visitas Agendadas">
                    <span className="signs-span">
                      <FontAwesomeIcon icon="clock" />
                      {request.visits_booked_count || 0}
                    </span>
                  </Tooltip>
                </Typography>
              </Grid>
            </Grid>

            <Grid container alignItems={"center"}>
              <Grid item md={5}>
                <Typography className="user-name" variant="body2">
                  Emissor: <b>{name}</b>
                </Typography>
                {request.elderly_name && (
                  <Typography className="user-name" variant="body2">
                    Utente: <b>{request.elderly_name}</b>
                  </Typography>
                )}
              </Grid>

              <Grid item md={2}>
                <Typography variant="body2">
                  {this.isPreAdmitted() && "Pré-Confirmado"}
                  {this.isCanceled() && "Cancelado"}
                  {this.isAdmitted() && "Admitido"}
                  {this.isPending() && "Pendente"}
                  {this.isInProgress() && "Em Curso"}
                  {this.isStandby() && (
                    <Tooltip
                      title={
                        request.standby_motive != null
                          ? "Motivo: " + request.standby_motives.motives
                          : ""
                      }
                    >
                      <span>Standby</span>
                    </Tooltip>
                  )}
                </Typography>
              </Grid>
              <Grid item md={3}>
                <div style={{ paddingLeft: 40 }}>
                  <Tooltip title="Data do Último Encaminhamento">
                    <Typography variant="caption" align="left">
                      {moment(request.regist, "YYYY-MM-DD HH:mm:ss").format(
                        "YYYY-MM-DD[;] HH:mm"
                      )}
                    </Typography>
                  </Tooltip>
                </div>
                <div style={{ paddingLeft: 40 }}>
                  <Tooltip title="Agendamento">
                    <Typography variant="caption" align="left">
                      {moment(bookcall).isAfter(yesterday) && (
                        <div>
                          <span class="font-weight-bold">
                            Contato agendado:
                          </span>
                          <div>{bookcall}</div>
                        </div>
                      )}
                    </Typography>
                  </Tooltip>
                </div>
              </Grid>
              <Grid item md={2}>
                <Tooltip title="Admissão confirmada por">
                  <Typography variant="body2">
                    <AdminView
                      adminId={request.admitted_by}
                      label={"CF"}
                      image={true}
                    />
                  </Typography>
                </Tooltip>
                <Tooltip title="Data de Admissão">
                  <Typography variant="body2">
                    {request.request_admitted && (
                      <span className="signs-span">
                        <FontAwesomeIcon icon="check-circle" />
                        {request.request_admitted}
                      </span>
                    )}
                  </Typography>
                </Tooltip>
                <Tooltip title="Data de Faturação">
                  <Typography variant="body2">
                    {request.request_admitted && (
                      <span
                        className={
                          request.invoice_status
                            ? request.invoice_status === "settled"
                              ? classes.payment_ok
                              : classes.payment_waiting
                            : classes.payment_nok
                        }
                      >
                        <FontAwesomeIcon
                          icon={faMoneyCheckAlt}
                          size={"1x"}
                          className="signs-span"
                        />
                        {request.invoice_date
                          ? moment(request.invoice_date).format("YYYY-MM-DD")
                          : "N/A"}
                      </span>
                    )}
                  </Typography>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={3}>
            {this.isCanceled() && (
              <Typography variant="caption">
                {cancelMotiveMap[request.cancel_reason]}
              </Typography>
            )}
            <Typography variant="caption">
              {request.notes && request.notes.length > 0 && (
                <>
                  {notes.map((note) => (
                    <>
                      [{formatDateTimeSmall(note.created_at)}] {note.note}
                      <br />
                    </>
                  ))}
                </>
              )}
            </Typography>
            {request.manual_selected_establishments > 0 && (
              <Tooltip title="Encaminhamento Manual">
                <Typography
                  style={{ textAlign: "center", width: "20px", margin: "0px" }}
                  gutterBottom
                  variant="subtitle2"
                >
                  M
                </Typography>
              </Tooltip>
            )}
          </Grid>
          <Grid item md={1} className="to-open">
            <Grid container>
              <Button
                size="small"
                color="primary"
                onClick={() => this.goTo(`/user_requests/${request.id}`)}
              >
                Open
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

const styles = (theme) => ({
  payment_ok: {
    color: "green",
  },
  payment_nok: {
    color: "red",
  },
  payment_waiting: {
    color: "goldenrod",
  },
});

UserRequestCardExclusive.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(UserRequestCardExclusive));
